<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="text-h4">
          <v-icon>{{vista.icono}}</v-icon>
          {{vista.titulo}}
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Registrar cosa</v-card-title>
          <v-card-text>
            <v-row v-if="form.editando">
              <v-col cols="3">
                <v-text-field disabled v-model="form.id" label="Id:"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <EmpleadoBuscador label="DNI Propietario" v-model="form.nuevaCosa.dni"></EmpleadoBuscador>
              </v-col>
              <v-col>
                <v-text-field label="Nombre" v-model="form.nuevaCosa.nombre"></v-text-field>
              </v-col>
              <v-col>
                <v-autocomplete
                  label="Tipo"
                  v-model="form.nuevaCosa.tipoId"
                  :items="form.tipos"
                  item-value="cosaTipoId"
                  item-text="nombre"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <DatePicker label="Fecha de alta" v-model="form.nuevaCosa.fecha"></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-alert type="error" text v-if="form.error">{{form.error}}</v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  color="primary"
                  class="float-right"
                  :loading="form.loading"
                  @click="InsertarCosa"
                  v-if="!form.editando"
                >Registrar</v-btn>
                <v-btn
                  color="primary"
                  class="float-right"
                  :loading="form.loading"
                  @click="EditarCosa"
                  v-if="form.editando"
                >Editar</v-btn>
                <v-btn
                  class="float-right mr-2"
                  :loading="form.loading"
                  @click="CancelarEdicion"
                  v-if="form.editando"
                >Cancelar</v-btn>
                <v-btn @click="mostrarMensaje">test</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Listado de cosas</v-card-title>
          <v-card-text>
            <v-data-table :items="cosas.items" :loading="cosas.loading" :headers="cosas.headers">
              <template v-slot:item.acciones="{item}">
                <v-btn color="info" text @click="CargarEdicion(item)">Editar</v-btn>
                <v-btn color="error" text @click="Desactivar(item)">Eliminar</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EmpleadoBuscador from "../../components/empleado/EmpleadoBuscador";
import DatePicker from "../../components/shared/DatePicker";
import CosaTipoService from "../../services/CosaTipo.service";
import CosaService from "../../services/Cosa.service";

export default {
  components: {
    EmpleadoBuscador,
    DatePicker,
  },
  data() {
    return {
      vista: {
        icono: "mdi-palette-swatch",
        titulo: "ABM Cosas",
      },
      cosas: {
        headers: [
          { text: "Tipo", value: "tipo" },
          { text: "Nombre", value: "nombre" },
          { text: "Propietario", value: "dni" },
          { text: "Fecha", value: "fechaAlta" },
          { text: "Acciones", value: "acciones", sortable: false },
        ],
        items: [],
        loading: false,
      },
      form: {
        nuevaCosa: {},
        error: null,
        tipos: [],
        loading: false,
        editando: false,
      },
    };
  },
  methods: {
    mostrarMensaje() {
      this.$toast.success("hola mundo");
    },
    ObtenerTipos() {
      CosaTipoService.ObtenerTodo().then((res) => {
        this.form.tipos = res.data;
      });
    },
    ObtenerCosas() {
      this.cosas.loading = true;
      CosaService.ObtenerTodo().then((res) => {
        this.cosas.items = res.data;
        this.cosas.loading = false;
      });
    },
    InsertarCosa() {
      this.form.loading = true;
      CosaService.Insertar(this.form.nuevaCosa)
        .then((res) => {
          this.form.loading = false;
          this.ObtenerCosas();
          this.form.nuevaCosa = {};
        })
        .catch((err) => {
          console.log(err.response);
          this.form.error = err.response.data.title;
          this.form.loading = false;
        });
    },
    EditarCosa() {
      this.form.loading = true;
      const cosa = { ...this.form.nuevaCosa, id: this.form.id };
      CosaService.Editar(cosa).then((res) => {
        this.form.loading = false;
        this.ObtenerCosas();
        this.CancelarEdicion();
      });
    },
    CargarEdicion(cosa) {
      this.form.nuevaCosa.nombre = cosa.nombre;
      this.form.nuevaCosa.tipoId = cosa.tipoId;
      this.form.nuevaCosa.dni = cosa.dni;
      this.form.nuevaCosa.fecha = cosa.fechaAlta;
      this.form.editando = true;
      this.form.id = cosa.id;
      this.form.error = "";
    },
    CancelarEdicion() {
      this.form.nuevaCosa = {};
      this.form.id = null;
      this.form.editando = false;
    },
    Desactivar(cosa) {
      this.cosas.loading = true;
      CosaService.Desactivar({ id: cosa.id }).then((res) => {
        this.cosas.loading = false;
        this.ObtenerCosas();
      });
    },
  },
  mounted() {
    this.ObtenerTipos();
    this.ObtenerCosas();
  },
};
</script>

<style>
</style>